import { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { formCounterSlice } from '../../../../redux/formCounter';
import UnActiveTab from '../../../../assets/icons/UnactiveTab';
import { iconSwitcher } from '../../../../utils/IconSwitcher';
import ActiveTab from '../../../../assets/icons/ActiveTab';
import Success from '../../../../assets/icons/Success';
import { AppDispatch } from '../../../../redux/store';
import '../FormSideBar.css';

type SideBarItemProps = {
    handleSideBarItemNavigation: (origin: string, destination: string) => void;
    isPathTitleShown: boolean;
    isFormFilled: boolean;
    currentForm: string;
    formPath: string[];
    formName: string;
    id: number;
    serviceProviderForms?: boolean;
};

export function SideBarItem({
    handleSideBarItemNavigation,
    isPathTitleShown,
    isFormFilled,
    currentForm,
    formPath,
    formName,
    id,
    serviceProviderForms,
}: SideBarItemProps): ReactElement | null {
    const { set } = formCounterSlice.actions;
    const dispatch = useDispatch<AppDispatch>();
    const active: boolean = formName === currentForm;

    const handleSideBarItemClick = (): void => {
        if (serviceProviderForms || isFormFilled) {
            const clickedScreenId = id + 1;
            handleSideBarItemNavigation(currentForm, formPath[clickedScreenId - 1]);
            dispatch(set(clickedScreenId));
        }
    };

    return (
        <div
            className={`sb-item ${active ? 'active' : ''} ${isPathTitleShown ? 'shown' : ''} ${
                isFormFilled ? 'filled' : ''
            }`}
            onClick={() => handleSideBarItemClick()}
        >
            <div className="item-left">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {iconSwitcher(formName, active)}
                </svg>
                <p className="sb-item-text">{formName}</p>
            </div>
            <div className="item-right">
                {active ? <ActiveTab /> : isFormFilled ? <Success /> : <UnActiveTab />}
            </div>
        </div>
    );
}
